import * as a from "react";
const l = (e) => /* @__PURE__ */ a.createElement(
  "svg",
  {
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...e
  },
  /* @__PURE__ */ a.createElement(
    "path",
    {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M19.66 17h-.004a3.002 3.002 0 01-2.124-.876l-1.657-1.657A5 5 0 0012.342 13H11a2 2 0 00-2 2v4h-.283L6.95 13.715l-.107-.33A2 2 0 004.94 12H4v-2h1a2 2 0 001.732-1H12.342a5 5 0 003.532-1.466h.001l1.657-1.658h.001A3 3 0 0119.656 5H20v12h-.34zm-5.2-1.12l1.66 1.66A5 5 0 0019.66 19H21a1 1 0 001-1V4a1 1 0 00-1-1h-1.34a5 5 0 00-3.54 1.46l-1.66 1.66a3 3 0 01-2.12.88H6a1 1 0 00-1 1H4c-1.1 0-2 .9-2 2v2a2 2 0 002 2h.94l.11.34 2 5.98A1 1 0 008 21h2a1 1 0 001-1v-5h1.34a2.998 2.998 0 012.12.88zM8 10a1 1 0 100 2h3a1 1 0 100-2H8z",
      fill: "#2d6ded"
    }
  )
);
export {
  l as default
};
